import { TipContent } from '../models/shared.models';

export const InfoNotifications = {
  digestFrequency: {
    message: 'To help you stay informed, the Platform Digest email contains links to new analyses, ' +
    'trending content, daily insights, and other content updates. ' +
    'It will be sent to your email based on the frequency chosen below.'
  },
  progressTracker: {
    message: 'You will be notified when the asset you follow has its first Technical Analysis images added, when the asset is first published or when a published asset is updated.'
  }
};

/**
 * DialogConfirmations defines flags for "Don't show this again" checkboxes in various dialogs.
 */
export const DialogConfirmations = {
  digestSubscriptions: {
    message: 'This content will be removed from your Subscription Digest email. You can enable it again at any time.'
  },
  progressTracker: {
    message: 'Are you sure you want to remove this progress tracker?'
  }
};

export const ProgressTrackerMessage: TipContent = {
  lineOne: 'This tool provides you with an up-to-date, filterable view into our content creation schedule.',
  lineTwo: 'Click a Report Name or Report Code to see available in-progress or finalized content in a new browser tab.',
  lineThree: 'Select and adjust filters to refine your list.',
};

export enum AlertMessages {
  SETTING_SAVED = 'Setting saved.',
  SETTING_NOT_SAVED = 'Setting was not saved. Please refresh the page or try again later.',
  SETTINGS_SAVED = 'Settings saved.',
  SETTINGS_NOT_SAVED = 'Settings was not saved. Please refresh the page or try again later.',
  SETTINGS_FIELDS_INVALID  = 'Please fill in the required fields.',
  PROGRESS_TRACKER_DELETED = 'Report progress tracker deleted.',
  SOMETHING_WENT_WRONG = 'Something went wrong. Please refresh the page or try again later.'
}

export enum NotificationsPreferenceMessages {
  DISABLE_LAST_SUBSCRIPTION = 'You must have at least one digest subscription selected.',
  NO_PROGRESS_TRACKERS = 'You are not currently following any analysis progress updates.',
}

export const NoAvailableContentMessage = {
  inProgressMessage: {
    title: 'No content at this time.',
    subTitle: 'Preliminary analysis content is accessible here when available. Use the <a href="/progress-tracker">Progress Tracker</a> tool to ' +
      'follow and subscribe to updates for specific analyses.'
  },
  searchMessage: {
    title: 'No matched results.',
    subTitle: 'Try adjusting search terms or check for any typos.',
  },
  defaultMessage: {
    title: 'Your search query did not find any matches.',
    subTitle: 'Try adjusting your search terms and filter settings.'
  },
  tagGroupLandingPageMessage: {
    title: 'No content available.',
    subTitle: 'There is no content to view at this time. Please check back later.'
  }
};
